module.exports = __webpack_public_path__ + "static/img/3_2.923fc593.jpg";